import React from 'react'
import methods, { defaultValues } from './methods'
import title from '../components/table/title'

export interface RowsCell {
    set(key: string, value: any): void
    get(key: string): any
    [key: string]: any
    key: string
    children?: RowsCell[]
    method: string
    id: string
}
export interface ColumnCell {
    title: string
    key: string
    dataIndex: string
    children: ColumnCell[]
    width?: number
    fixed?: string
    render(text: ColumnValue | undefined, row: RowsCell, index: string | number): any
}

export interface CellFormatter {
    prefix: string | null
    suffix: string | null
    color: string | null
}
export interface ColumnValue {
    method: string
    value: string | number
    formatter: CellFormatter
    parent: RowsCell | null
    key?: string
    id: string
}

const newCellValue = ({
    value,
    method,
    color,
    prefix,
    suffix,
    parent,
    key
}: {
    value: string | number
    method: string
    color?: string
    prefix?: string
    suffix?: string
    key?: string
    id?: string
    parent: RowsCell | null
}): ColumnValue => {
    return {
        value,
        method,
        key,
        formatter: {
            color,
            prefix,
            suffix
        },
        parent,
        id: String(key)
    }
}

const newRowsCell = (value: string, parent, id): RowsCell => ({
    key: value,
    id: id,
    method: methods.text,
    '0': newCellValue({ value, method: methods.text, parent, key: id }),
    set: function (key, value) {
        this[key] = value
    },
    get: function (key) {
        return this[key]
    }
})

const newColumnsCell = (value: string, key: string, groupColumn: boolean = false): ColumnCell => ({
    title: value,
    key: key,
    dataIndex: key,
    width: 100,
    children: [],
    fixed: key == '0' ? 'left' : null,
    render: (
        cell = newCellValue({
            value: defaultValues.void,
            method: methods.void,
            parent: null
        }),...props
    ) => {
        const formatNumber = () => {
            switch (cell.method) {
                case methods.formated:
                    return cell.value
                case methods.sum:
                    return Math.round(parseFloat(`${cell.value}`) * 100) / 100
                case methods.avg:
                    return Math.round(parseFloat(`${cell.value}`) * 100) / 100
                default:
                    return cell.value
            }
        }
    
        return (
            <label key={`${cell.id}`} style={{ color: cell.formatter.color, padding: '5px' }}>
                {cell.formatter.prefix}
                {formatNumber()}
                {cell.formatter.suffix}
            </label>
        )
    }
})

export default {
    newRowsCell,
    newCellValue,
    newColumnsCell
}
